import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import { ImageCoordinates } from 'store/search/types';

interface OpProductPreviewElement extends HTMLElement {
  contentSrc: string;
  backgroundSrc: string;
  foregroundSrc: string;
  maskPosition: ImageCoordinates;
}

const OpProductPreview = createWrapper<OpProductPreviewElement>('op-product-preview');

export default OpProductPreview;
